import { combineReducers } from 'redux';
import { getTeamsById } from './utils';

const byTeamId = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getTeamsById(action.resp.games);
    default:
      return state;
  }
};

export default combineReducers({
  byTeamId,
});
